import { REHYDRATE } from 'redux-persist';
import { all, call, delay, put, select, takeLatest } from 'redux-saga/effects';
import Apis from '../../../api';
import { setInterceptor, setJwtToken } from '../../../api/apiServices';
import { HEADERMENU_PATH } from '../../../routes/RoutesURL';
import { RootState } from '../../../store/rootReducer';
import AnnoucementActions from '../../main/announcements/redux/actions';
import constantsActions from '../../main/constants/redux/actions';
import { onboardingCompletedPercentage } from '../../main/onboarding/utils';
import { isUserProfileComplete } from '../../utils/validation';
import { checkOnbordingFlow, getRedirectUrlAfterLogin, isNonAuthenticatedUrl } from '../utils';
import { UserStatus } from '../utils/Status';
import actions from './actions';
import types, { CommonAction, Investor, User, UserState, loginReqAction } from './types';

const getUser = (state: RootState) => state.user;

const loginReq = function* loginReq({ payload }: loginReqAction) {
    try {
        const { user_data, url_key } = payload;
        if (!user_data.jwtToken) return;
        yield delay(800);
        let userData: UserState = user_data;
        yield call(setJwtToken, user_data.jwtToken);
        yield put(actions.loginReqSuccess());
        if (userData.uuid) {
            const res: { data: Investor } = yield call(Apis.getInvestorProfile, userData.uuid);

            let investorProfile: Investor = res.data;
            // const isTeamMember = userData.user?.userType === 'TeamMember';
            // if (isTeamMember) {
            //     const { data: teamData }: { data: Investor } = yield call(Apis.investorByTeam);
            //     investorProfile = teamData;
            // }
            yield put(actions.updateInvestorInfo(investorProfile));
            userData = { ...userData, investor: investorProfile };
        }
        yield put(actions.setUserData(userData));
        yield call(window.open, getRedirectUrlAfterLogin(userData, url_key), '_self');
    } catch (err) {
        yield put(actions.loginReqFailed());
    }
};

const signUpReq = function* signUpReq({ payload }: loginReqAction) {
    try {
        yield delay(800);
        const userData: UserState = payload.user_data;
        yield put(actions.setUserData(userData));
    } catch (err) {}
};

const appInit = function* appInit() {
    yield call(setInterceptor);
    const curPath = window.location.pathname;
    const curHash = window.location.hash || '';
    const fullPath = `${curPath}${curHash}`;
    const user: UserState = yield select(getUser);
    let isAuthenticated = false;
    if (user.jwtToken && user.uuid) {
        try {
            yield call(setJwtToken, user.jwtToken);
            isAuthenticated = true;
            //Calling Investor and User api
            const res: [
                {
                    data: User;
                },
                {
                    data: Investor;
                },
            ] = yield all([call(Apis.getUserProfile, user.uuid), call(Apis.getInvestorProfile, user.uuid)]);
            let investorProfile: Investor = res[1].data;
            // const isTeamMember = res[0].data.userType === 'TeamMember';
            // if (isTeamMember) {
            //     const { data: teamData }: { data: Investor } = yield call(Apis.investorByTeam);
            //     investorProfile = teamData;
            // }
            yield put(actions.updateUserProfile(res[0].data));
            yield put(actions.updateInvestorInfo(investorProfile));
            yield put(constantsActions.fetchConstants());
            //Announcement api
            const { data } = yield call(Apis.getAnnouncements);
            yield put(AnnoucementActions.setAnnoucements(data || []));
        } catch (err) {
            yield put(actions.removeUserData());
            yield call(window.open, '/login', '_self');
        }
    }
    const url = checkOnbordingFlow(user);

    if (curPath !== '/login' && !isAuthenticated && !isNonAuthenticatedUrl(curPath)) {
        yield call(
            window.open,
            fullPath !== '/' ? `/login?url_key=${encodeURIComponent(fullPath)}` : '/login',
            '_self',
        );
    } else if (isAuthenticated && url && url !== curPath) {
        yield call(window.open, url, '_self');
    } else if (
        curPath.includes(HEADERMENU_PATH.onboarding) &&
        onboardingCompletedPercentage(user.user, user.investor) === 100
    ) {
        yield call(window.open, HEADERMENU_PATH.deals, '_self');
    } else if (
        isAuthenticated &&
        !url &&
        user.user?.status === UserStatus.pendingActivation &&
        curPath !== HEADERMENU_PATH.accountActivationWithOtp &&
        isUserProfileComplete(user?.user?.userProfile) &&
        curPath !== HEADERMENU_PATH.myinfoRedirect
    ) {
        yield call(window.open, HEADERMENU_PATH.accountActivationWithOtp, '_self');
    }
};

const fetchInvestorByUUID = function* fetchInvestorByUUID(action: CommonAction) {
    try {
        const res: { data: Investor } = yield call(Apis.getInvestorProfile, action.payload);
        yield put(actions.updateInvestorInfo(res.data));
    } catch (err) {
        console.log('err:', err);
    }
};

export default function* sagas() {
    yield takeLatest(types.LOGIN_REQ, loginReq);
    yield takeLatest(types.SIGN_UP_REQ, signUpReq);
    yield takeLatest(types.FETCH_INVETSOR_BY_UUID, fetchInvestorByUUID);
    yield takeLatest(REHYDRATE, appInit);
}
